import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  appearance: {
    property: 'appearance'
  },
  transform: {
    property: 'transform'
  },
  transformOrigin: {
    property: 'transformOrigin'
  },
  visibility: {
    property: 'visibility'
  },
  userSelect: {
    property: 'userSelect'
  },
  pointerEvents: {
    property: 'pointerEvents'
  },
  overflowWrap: {
    property: 'overflowWrap'
  },
  boxSizing: {
    property: 'boxSizing'
  },
  cursor: {
    property: 'cursor'
  },
  resize: {
    property: 'resize'
  },
  objectFit: {
    property: 'objectFit'
  },
  objectPosition: {
    property: 'objectPosition'
  },
  float: {
    property: 'float'
  },
  fill: {
    property: 'fill'
  },
  stroke: {
    property: 'stroke'
  },
  outline: {
    property: 'outline'
  },
  outlineColor: {
    property: 'outlineColor'
  },
  outlineOffset: {
    property: 'outlineOffset'
  },
  outlineStyle: {
    property: 'outlineStyle'
  },
  outlineWidth: {
    property: 'outlineWidth'
  },
  listStyle: {
    property: 'listStyle'
  },
  listStyleImage: {
    property: 'listStyleImage'
  },
  listStylePosition: {
    property: 'listStylePosition'
  },
  listStyleType: {
    property: 'listStyleType'
  }
};
const other = system(config);

export { other };
